var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDataLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 153,
    viewBox: "0 0 205 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.29,
    cy: 122.4,
    rx: 73.6174,
    ry: 30.1565,
    fill: "#B9E8F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.5135 80.3721L145.357 90.1286L124.957 101.659V110.529L73.5135 140.685L22.0701 110.529L73.5135 80.3721Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.377 53.9826L75.2173 46.1211L24.6426 70.725L75.2173 95.3289L125.792 70.725L103.794 60.0235",
    stroke: "#232F3E",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7427 110.869L74.5253 140.139V95.791L47.9166 114.417L25.7427 102.887V110.869Z",
    fill: "#E5F6FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5253 47.0088L25.7427 70.0697L74.5253 94.9044V47.0088Z",
    fill: "#B9E8F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4006 45.7812V96.3378L124.957 71.503L74.4006 45.7812Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4006 94.5635V139.798L124.07 110.529V102.546L101.896 114.963L74.4006 94.5635Z",
    fill: "#7CCEE9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7427 106.435V109.982",
    stroke: "#232F3E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7433 109.982L74.6554 140.685",
    stroke: "#232F3E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M125.081 109.982L74.654 140.685",
    stroke: "#232F3E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1499 49.7666L25.1673 70.4823",
    stroke: "#232F3E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8645 27.9376L2.54888 50.6835C2.0424 50.9037 1.4533 50.6716 1.23308 50.1652C1.01287 49.6587 1.24495 49.0696 1.75143 48.8494L54.6701 25.8412C55.0398 25.6702 55.4925 25.7371 55.7973 26.0419L75.3621 45.6067C75.7526 45.9972 75.7526 46.6304 75.3621 47.0209C74.9716 47.4114 74.3384 47.4114 73.9479 47.0209L54.8645 27.9376Z",
    fill: "#232F3E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M147.733 49.7666L130.402 67.4082",
    stroke: "#232F3E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.06 26.0682L74.5213 45.607C74.1308 45.9975 74.1308 46.6307 74.5213 47.0212C74.9118 47.4117 75.545 47.4117 75.9355 47.0212L95.0375 27.9192L96.3325 28.4264C96.8467 28.6278 97.4269 28.3742 97.6283 27.86C97.8297 27.3457 97.5761 26.7656 97.0619 26.5642L95.1863 25.8295C95.1169 25.7999 95.0448 25.7785 94.9716 25.7652C94.8093 25.7355 94.6457 25.7473 94.4941 25.7948C94.44 25.8118 94.387 25.8334 94.3358 25.8598C94.2333 25.9123 94.1398 25.9825 94.06 26.0682ZM107.829 33.5077C107.322 33.2874 107.09 32.6983 107.311 32.1919C107.531 31.6854 108.12 31.4533 108.626 31.6735L148.131 48.8496C148.638 49.0698 148.87 49.6589 148.65 50.1654C148.43 50.6719 147.84 50.904 147.334 50.6838L107.829 33.5077Z",
    fill: "#232F3E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7444 70.4824L13.3264 80.301M0.999975 90.0472L6.23075 85.9114",
    stroke: "#232F3E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6562 95.2739L47.4915 114.332L1.00051 90.0474",
    stroke: "#232F3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M130.663 74.0299L151.859 88.273",
    stroke: "#232F3E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6558 95.2733L101.821 114.331L151.859 88.2728",
    stroke: "#232F3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5945 97.2725L74.5945 132.811",
    stroke: "#232F3E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5945 53.5322V71.2714",
    stroke: "#232F3E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5945 78.0518V85.1474",
    stroke: "#232F3E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M125.082 102.887V109.982",
    stroke: "#232F3E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M103.794 60.0235L125.792 70.725L75.2173 95.3289L24.6426 70.725L75.2173 46.1211L91.377 53.9826",
    stroke: "#232F3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M194.618 22.5242C195.849 23.4338 196.665 24.59 197.02 25.6833C197.375 26.7789 197.251 27.725 196.765 28.3827C196.278 29.0403 195.41 29.4366 194.259 29.4178C193.109 29.3989 191.765 28.9577 190.534 28.048C189.304 27.1384 188.488 25.9823 188.133 24.889C187.777 23.7934 187.902 22.8473 188.388 22.1896C188.874 21.532 189.742 21.1356 190.894 21.1545C192.043 21.1733 193.388 21.6146 194.618 22.5242Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M201.892 29.6936C202.038 30.0626 201.946 30.775 201.067 31.7556C200.233 32.6863 198.869 33.6282 197.16 34.3037C195.451 34.9793 193.812 35.2244 192.567 35.1155C191.255 35.0008 190.7 34.5441 190.554 34.175C190.409 33.8059 190.501 33.0936 191.38 32.113C192.214 31.1822 193.578 30.2404 195.287 29.5648C196.996 28.8893 198.635 28.6442 199.88 28.7531C201.192 28.8678 201.746 29.3245 201.892 29.6936Z",
    fill: "#00A8E1",
    stroke: "#232F3E",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M200.941 22.9534C201.108 24.4743 200.814 25.8584 200.252 26.8614C199.689 27.8664 198.91 28.4175 198.097 28.5072C197.284 28.5968 196.404 28.2287 195.636 27.3704C194.869 26.5138 194.28 25.2271 194.112 23.7062C193.945 22.1854 194.239 20.8013 194.801 19.7983C195.364 18.7932 196.143 18.2421 196.956 18.1525C197.769 18.0629 198.649 18.431 199.417 19.2893C200.184 20.1459 200.773 21.4326 200.941 22.9534Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3865 71.8452C97.2923 60.9131 97.0155 31.6944 111.308 15.8845C132.023 -7.03023 160.977 2.05586 153.339 29.8163C149.472 43.8718 131.094 37.914 133.826 23.6076C136.487 9.67586 166.644 5.86849 172.852 25.3815C177.3 39.3611 170.192 67.7658 189.729 61.8869C198.158 59.3508 198.853 48.4771 198.002 41.2529",
    stroke: "#232F3E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "2 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataLarge);
export default __webpack_public_path__ + "static/media/NoDataLarge.b692dd2fbcbfd3c7c1eaf0782380af5e.svg";
export { ForwardRef as ReactComponent };